import styled, { css } from 'styled-components';
var ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-1a49jdb-0"
})(["background-color:", ";display:flex;flex-direction:row;justify-content:center;position:relative;width:100%;z-index:1;", " ", ""], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && css(["margin:0 auto;flex-direction:column;"]);
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return !isMobile && css(["box-shadow:0 -10px 10px rgba(0,0,0,0.1);"]);
});
export default ContentContainer;